import { render, staticRenderFns } from "./kxd-render-v2.vue?vue&type=template&id=48b8f79b&scoped=true&"
import script from "./kxd-render-v2.vue?vue&type=script&lang=js&"
export * from "./kxd-render-v2.vue?vue&type=script&lang=js&"
import style0 from "./kxd-render-v2.vue?vue&type=style&index=0&id=48b8f79b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48b8f79b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\1603014\\develop\\qplus\\qpeplus\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('48b8f79b', component.options)
    } else {
      api.reload('48b8f79b', component.options)
    }
    module.hot.accept("./kxd-render-v2.vue?vue&type=template&id=48b8f79b&scoped=true&", function () {
      api.rerender('48b8f79b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/js/components/emap/KXD_VUE_MAP/src/packages/KXD-map/component/kxd-render-v2.vue"
export default component.exports